export * from './enum'
export * from './OrderLogsEnum'

export const SESSION_STORAGE_KEY_FILTERS = 'filters'
export const SESSION_STORAGE_KEY_HANDOVER_STATE = 'handoverState'
export const LOCAL_STORAGE_KEY_ITEM_LOOKUP_HISTORY_STATE = 'itemLookupHistoryState'
export const SESSION_STORAGE_KEY_CONSIGNMENT_STATE = 'consignmentState'

export const ON_LOGOUT_CLEAR_LOCAL_STORAGE_KEYS = [LOCAL_STORAGE_KEY_ITEM_LOOKUP_HISTORY_STATE]
